<template>
  <!--<div>-->
  <div class="mobileBox">
    <!--banner+导航-->
    <div class="topBanner">
      <img class="bannerImg" src="../../../assets/img/serviceBanner_m.png"/>


      <top-nav></top-nav>


    </div>

    <div class="servicesContent" id="m1">
      <div class="services01 animated" :class="animates.mm1 ? 'fadeInUp' : 'hideBox'">
        <div class="text1">微信朋友圈广告</div>
        <div class="text2">让产品、内容、服务，这些身边的事物， 恰好出现.</div>
        <div class="btns" @click="navClick('/apply_m')">联系我们</div>
        <div class="imgs"><img src="../../../assets/icon/servicesImg1.png"/></div>
      </div>
      <div class="services01"  id="m2">
        <div class="animated" :class="animates.mm2 ? 'fadeInUp' : 'hideBox'">
        <div class="text1">微信支付成功界面广告</div>
        <div class="text2">每日超过10000次曝光，帮助你吸引优质的潜在客户. </div>
        <div class="btns" @click="navClick('/apply_m')">CONTACT</div>
        <div class="imgs"><img src="../../../assets/icon/servicesImg2.png"/></div>
        </div>
      </div>

      <div class="services02" id="m3">
        <div class="animated" :class="animates.mm3 ? 'fadeInUp' : 'hideBox'">
        <div class="title1">多平台营销</div>
        <ul class="servicesUl">
          <li class="servicesLi">
            <div class="iconBox"><img src="../../../assets/icon/servicesIcon1.png"/></div>
            <div class="textBox">
              <div class="title2">支付宝境外红包</div>
              <div class="texts">支付宝境外红包活动，活动期间内每人每月可领3次红包，在门店付款时自动立减红包金额，最高可得2888元。红包的领取和使用都没有门槛，在门店付款时自动立减红包金额.</div>
            </div>
          </li>
          <li class="servicesLi">
            <div class="iconBox"><img src="../../../assets/icon/servicesIcon2.png"/></div>
            <div class="textBox">
              <div class="title2">微信支付红包</div>
              <div class="texts">微信红包可以让消费者在消费后摇一摇，已获得代金券或者直接免单的机会。红包的领取和使用都没有门槛.</div>
            </div>
          </li>
          <li class="servicesLi">
            <div class="iconBox"><img src="../../../assets/icon/servicesIcon3.png"/></div>
            <div class="textBox">
              <div class="title2">支付宝/微信支付节日活动</div>
              <div class="texts">支付宝于微信支付在节假日期间都提供推广活动，用以帮助商家进行推广或提供优惠代金券，只需消费者扫码即可领取.</div>
            </div>
          </li>
        </ul>
        </div>
      </div>

      <div class="services02" id="m4">
        <div class="animated" :class="animates.mm4 ? 'fadeInUp' : 'hideBox'">
        <div class="title1">微信支付推广活动</div>
        <ul class="servicesUl">
          <li class="servicesLi">
            <div class="iconBox"><img src="../../../assets/icon/servicesIcon4.png"/></div>
            <div class="textBox">
              <div class="title2">微信朋友圈广告</div>
              <div class="texts">丰富的广告形态，满足日益精细的投放需求。将你的品牌推广到目前微信澳洲拥有的2,900,000活跃用户手机中.</div>
            </div>
          </li>
          <li class="servicesLi">
            <div class="iconBox"><img src="../../../assets/icon/servicesIcon5.png"/></div>
            <div class="textBox">
              <div class="title2">微信支付成功界面广告</div>
              <div class="texts">在我们SuperiorPay的微信支付成功界面做推广广告，以获得每日10000+的曝光量.</div>
            </div>
          </li>
          <li class="servicesLi">
            <div class="iconBox"><img src="../../../assets/icon/servicesIcon6.png"/></div>
            <div class="textBox">
              <div class="title2">微信“境外游礼包”小程序</div>
              <div class="texts">这是微信支付向海外市场发布的小程序，其中包含商家和微信支付提供的优惠信息.</div>
            </div>
          </li>
        </ul>
        </div>
      </div>

      <div class="services02" id="m5">
        <div class="animated" :class="animates.mm5 ? 'fadeInUp' : 'hideBox'">
        <div class="title1">支付宝推广活动</div>
        <ul class="servicesUl">
          <li class="servicesLi">
            <div class="iconBox"><img src="../../../assets/icon/servicesIcon7.png"/></div>
            <div class="textBox">
              <div class="title2">支付宝“发现”推广界面</div>
              <div class="texts">在支付宝发现平台上的商家列表可以详细描述商店位置，客户评论以及优惠活动，并且会在支付宝App中进行推送.</div>
            </div>
          </li>
          <li class="servicesLi">
            <div class="iconBox"><img src="../../../assets/icon/servicesIcon8.png"/></div>
            <div class="textBox">
              <div class="title2">支付宝城市卡</div>
              <div class="texts">商户的优惠活动会被列于支付宝城市卡上，海外游客可以在页面上发现优惠活动并直接参与.</div>
            </div>
          </li>
          <li class="servicesLi">
            <div class="iconBox"><img src="../../../assets/icon/servicesIcon9.png"/></div>
            <div class="textBox">
              <div class="title2">支付宝周活动</div>
              <div class="texts">支付宝周活动中，支付宝会为商户提供显眼的推送版位，并且提供大量优惠活动，例如：1元换购20元，等.</div>
            </div>
          </li>
        </ul>
        </div>
      </div>

    </div>

    <!--底部-->
    <div class="footer_m ">
      <div class="footer_mText">
        Supay Technology Pty Ltd. Authorized Representative Number 001283947
        <div class="goTopBtn" @click="toTop"><img src="../../../assets/icon/goTopIcon.png"/></div>
      </div>
    </div>

  </div>
  <!--</div>-->
</template>

<script>
  import topNav from './nav_m'
  let timer = null; //定义初始值
  export default {
    name: "services_m",
    components:{topNav},
    props:{
      step:{   //此数据是控制动画快慢的
        type:Number,
        default:50
      }
    },
    data() {
      return {
        animates:{
          mm1:false,
          mm2:false,
          mm3:false,
          mm4:false,
          mm5:false,
        },
      }
    },
    destroyed(){
      window.removeEventListener('scroll', this.handleScroll);//监听页面滚动事件
    },
    mounted () {
      document.documentElement.scrollTop=0;

      this.animates.mm1 = true;
      window.addEventListener('scroll', this.handleScroll)
    },
    methods:{
      //  点击导航
      navClick(url){
        this.$router.push(url);
      },

      handleScroll () {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

        // var offsetTop1 = document.querySelector('#m1').offsetTop;
        var offsetTop2 = document.querySelector('#m2').offsetTop;
        var offsetTop3 = document.querySelector('#m3').offsetTop;
        var offsetTop4 = document.querySelector('#m4').offsetTop;
        var offsetTop5 = document.querySelector('#m5').offsetTop;



        if (scrollTop > offsetTop2-800) {
          this.animates.mm2 = true
        } else {
          // this.animates.mm2 = false
        }
        if (scrollTop > offsetTop3-800) {
          this.animates.mm3 = true
        } else {
          // this.animates.mm3 = false
        }
        if (scrollTop > offsetTop4-800) {
          this.animates.mm4 = true
        } else {
          // this.animates.mm4 = false
        }
        if (scrollTop > offsetTop5-800) {
          this.animates.mm5 = true
        } else {
          // this.animates.mm5 = false
        }
      },

      //置顶
      toTop(){ // 动画

        timer = setInterval(function () {
          let osTop = document.documentElement.scrollTop || document.body.scrollTop;
          let ispeed = Math.floor(-osTop / 5);
          document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
          // this.isTop = true
          if (osTop === 0) {
            clearInterval(timer)
          }
        },30)

      },
    }
  }
</script>

<style scoped>
  .mobileBox{width: 100%;height: auto;}
  .mobileBox .topBanner{width: 100%;height: auto;position: relative;}
  .mobileBox .topBanner .bannerImg{width: 100%;height: auto;}

  .servicesContent{width: 100%;height: auto;}

  /*板块1*/
  .services01{width: calc(100% - 30px);height: auto;margin: auto;}
  .services01:nth-of-type(1){border-bottom: 2px solid #c1c1c1;}
  .services01 .text1{
    font-size: 1.5rem;
    font-family: MontserratRegular;
    color: #4a4a4a;
    /*line-height: 2rem;*/
    margin-top: 2rem;
    width: 100%;
    padding: 10px 0;
    text-align: center;
  }
  .services01 .text2{
    font-size: 0.75rem;
    font-family: Montserrat300;
    color: #4a4a4a;
    width: 100%;
    padding: 10px 0;
    text-align: center;
  }
  .services01 .btns{
    font-size: 0.75rem;
    width: 5.7rem;
    font-family: MontserratMedium;
    text-align: center;
    color: #4a4a4a;
    height: 1.875rem;
    line-height: 1.875rem;
    margin: 2rem auto;
    border: 1px solid #4a4a4a;
    border-radius: 4px;
    cursor: pointer;
  }
  .services01 .imgs{
    width: 80%;
    height: auto;
    margin: auto;
  }
  .services01 .imgs>img{width: 100%;}


  /*板块2*/
  .services02{width: calc(100% - 30px);background-color: #f6f6f6;padding: 1.5rem 15px;}
  .services02 .title1{width: 100%;
    padding: 1rem 0;
    font-family: Montserrat300;
    font-size: 1.5rem;
    text-align: center;
    border-bottom: 1px solid #979797;}
  .services02 .servicesUl{
    width: 100%;
    height: auto;
    padding: 10px 0;
  }
  .services02 .servicesUl .servicesLi{
    width: 100%;
    padding: 20px 0;
    height: auto;
    position: relative;
  }
  .services02 .servicesUl .servicesLi .iconBox{
    width: 20%;
    position: absolute;
    text-align: center;
  }
  .services02 .servicesUl .servicesLi .iconBox>img{
    transform: scale(0.8);
  }
  .services02 .servicesUl .servicesLi .textBox{
    padding-left: 20%;
    width: 80%;
  }
  .services02 .servicesUl .servicesLi .textBox .title2{
    width: 100%;
    height: auto;
    font-family: Montserrat600;
    font-size: 1rem;
    color: #4a4a4a;
    line-height: 2rem;
  }
  .services02 .servicesUl .servicesLi .textBox .texts{
    width: 100%;
    height: auto;
    font-family: Montserrat300;
    font-size: 0.875rem;
    color: #4a4a4a;
    line-height: 1.3rem;
  }





  .hideBox{display: none;}

</style>
